import { type FormProps, Form as StandardForm } from '@/components/Form'

import styles from './styles.module.scss'

export function Form({ children, ...props }: React.PropsWithChildren<FormProps>) {
  return (
    <StandardForm {...props} className={styles.form}>
      {children}
    </StandardForm>
  )
}
